export default "__VITE_ASSET__C2hrtOM1__"